<template>
  <div class="container" v-if="!isToDetail">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
        v-model="customerSearchText"
        search
        clearable
        placeholder="搜索客户..."
        @on-change="searchCustomer"
        icon="ios-search"
        style="width: 250px; margin-right: 30px"
        >
        </Input>
        <Select
          placeholder="标签筛选"
          v-model="tags"
          label-in-value
          multiple
          @on-change="choseTags"
          style="width: 200px"
        >
          <Option
            v-for="item in tagsList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="limit"
          @on-change="loadCustomer"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button
          v-if="
            user.superAdmin ||
            arrayIntersection(['salesAssist'], user.simpleRole).length > 0
          "
          @click="$refs.UploadFileModal.openModal()"
          style="margin-right: 12px"
          >Excel导入客户</Button
        >
        <Button
          v-if="
            user.superAdmin ||
            arrayIntersection(['salesAssist'], user.simpleRole).length > 0
          "
          @click="reloadCustomerStatusBtnClicked()"
          :loading="reloadCusStatusBtnLoading"
          style="margin-right: 12px"
          >重载状态</Button
        >
        <Button
          class="add-customer"
          type="primary"
          v-if="
            user.superAdmin ||
            arrayIntersection(['salesAssist'], user.simpleRole).length > 0
          "
          @click="$refs.AddNewCustomerDrawer.openDrawer()"
          >新增客户</Button
        >
        <!-- <Button
          class="bulk-permissions"
          type="success"
          @click="$refs.BulkPermissionsModal.openModal()"
          >批量权限管理</Button
        > -->
        <Button
          class="customer-permissions"
          @click="$router.push('/home/customerPermissions')"
          type="success"
          >客户权限管理</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="customerList"
        :height="tableHeight"
      >
        <template slot-scope="{ row }" slot="tags">
          <span v-for="tag in row.tags">
            <Tag>{{ tag }}</Tag>
          </span>
        </template>
      </Table>
    </div>
    <UploadFileModal ref="UploadFileModal" @uploadSuccess="loadCustomer" />
    <AddNewCustomerDrawer ref="AddNewCustomerDrawer" />
    <BulkPermissionsModal ref="BulkPermissionsModal" />
  </div>
  <router-view v-else />
</template>

<script>
import UploadFileModal from "./UploadFileModal.vue";
import AddNewCustomerDrawer from "./AddNewCustomerDrawer.vue";
import BulkPermissionsModal from "./BulkPermissionsModal";
import { mapState, mapActions } from "vuex";
import { arrayIntersection, cusStatusTrans } from "@/utils";
import _ from "lodash";

export default {
  name: "Customer",
  components: {
    AddNewCustomerDrawer,
    UploadFileModal,
    BulkPermissionsModal,
  },
  data() {
    return {
      isToDetail: false,
      importCusfile: undefined,
      addNewDrawer: false,
      openedCustomer: undefined,
      reloadCusStatusBtnLoading: false,
      page: 0,
      tableLoading: false,
      customerSearchText: "",
      filterQuery: {},
      limit: 20,
      tags: [],
      columns: [
        {
          title: "行",
          key: "row",
          width: 80,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "状态",
          key: "row",
          width: 80,
          align: "center",
          render: (h, params) => h("span", cusStatusTrans[params.row.status])
        },
        {
          title: "客户名字",
          key: "code",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.isToDetail = true;
                      this.$router.push({
                        name: "customerDetail",
                        query: {
                          id: params.row._id,
                        },
                      });
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
        {
          title: "简称",
          key: "abbr",
        },
        {
          title: "标签",
          key: "tags",
          align: "center",
          slot: "tags",
          // render: (h, params) => h("span", params.row.tags),
        },
        {
          title: "短号",
          key: "NoId",
          align: "center",
        },
      ],
      tagsList: [
        {
          value: "搅拌站",
          label: "搅拌站",
        },
        {
          value: "管桩",
          label: "管桩",
        },
        {
          value: "构件",
          label: "构件",
        },
        {
          value: "管道",
          label: "管道",
        },
        {
          value: "水泥制品",
          label: "水泥制品",
        },
        {
          value: "中铁",
          label: "中铁",
        },
        {
          value: "中建",
          label: "中建",
        },
        {
          value: "中交",
          label: "中交",
        },
      ],
      tableHeight: 300,
    };
  },
  watch: {
    // 监听路由的切换
    "$route.path": function (n, o) {
      if (n === "/home/customer") {
        this.isToDetail = false;
      }
    },
  },
  computed: {
    ...mapState({
      customerList: (state) => state.customer.customers,
      totalRows: (state) => state.customer.totalCounts,
      user: (state) => state.auth.currentUser,
    }),
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getCustomers: "customer/getCustomersAction",
      reloadCustomerStatus: "customer/reloadCustomerStatusAction",
      getSimpleUsersList: "user/getSimpleUserListAction",
    }),
    async loadCustomer(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.customerSearchText) {
        this.filterQuery.name = this.customerSearchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getCustomers(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer: _.debounce(function () {
      this.page = 0;
      this.loadCustomer();
    }, 1000),
    choseTags(e) {
      this.page = 0;
      if (e.length > 0) {
        const tags = e.map((x) => x.value).join(",");
        this.filterQuery.tags = tags;
      } else {
        delete this.filterQuery.tags;
      }
      this.loadCustomer();
    },
    async reloadCustomerStatusBtnClicked() {
      try {
        this.reloadCusStatusBtnLoading = true;
        await this.reloadCustomerStatus();
        this.reloadCusStatusBtnLoading = false;
        this.$Message.success('成功');
      } catch (error) {
        this.$Message.error(error)
        this.reloadCusStatusBtnLoading = false;
      }
    }
  },
  created() {
    this.loadCustomer();
    this.getSimpleUsersList({ limit: 999 });
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    if (this.$route.path === "/home/customer/customer_detail") {
      this.isToDetail = true;
    }
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)

.add-customer
  margin-right 12px
</style>